import { NotificationsIcon } from "../../../../assets"
import styles from "./style.module.css"

export const NotificationsButton = () =>{

    const onNotificationButtonClick = () =>{
        console.log("onNotificationButtonClick");
    }

    return(

        <div onClick={onNotificationButtonClick} className={styles.container}>

            <NotificationsIcon className={styles.icon}/>

            Notifications
        </div>

    )

}